/* ONX Customs v4 — CRO-optimised Theme JS */
(function(){
'use strict';

/* ── CART ENGINE ──────────────────────────────── */
var Cart={
  thresh:(window.ONX&&window.ONX.thresh||150)*100,
  init:function(){
    var s=this;
    s.drawer=document.getElementById('cdw');
    s.overlay=document.getElementById('cov');
    s.itemsEl=document.getElementById('citems');
    s.totalEl=document.getElementById('ctotal');
    s.fillEl=document.getElementById('shipfill');
    s.shipTxt=document.getElementById('shiptxt');
    // Open triggers
    document.querySelectorAll('[data-oc]').forEach(function(b){b.addEventListener('click',function(){s.open()})});
    var cl=document.getElementById('cdw-close');
    if(cl)cl.addEventListener('click',function(){s.close()});
    if(s.overlay)s.overlay.addEventListener('click',function(){s.close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')s.close()});
    document.addEventListener('cart:refresh',function(){s.refresh()});
    // Init count
    s.fetchCount();
  },
  fetchCount:function(){
    var s=this;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){s.updateCount(SP.realCount(c))}).catch(function(){});
  },
  /* DOM-only reveal. Separated from open() so add-to-cart can render the cart
     FIRST and then show it, instead of opening an empty drawer that fills in. */
  show:function(){
    if(!this.drawer)return;
    this.lastFocus=document.activeElement;
    this.drawer.classList.add('open');
    if(this.overlay)this.overlay.classList.add('open');
    document.body.style.overflow='hidden';
    this.drawer.setAttribute('aria-hidden','false');
    /* Move focus into the dialog so keyboard and screen-reader users land inside
       it, matching the aria-modal the markup already declares. */
    var f=document.getElementById('cdw-close');
    if(f)try{ f.focus({preventScroll:true}); }catch(e){ f.focus(); }
  },
  open:function(){
    this.show();
    this.refresh();
  },
  /* Render the current cart, then reveal. One fetch, no empty flash. */
  openAfterRefresh:function(){
    var s=this;
    return this.refresh().then(function(){ s.show(); }).catch(function(){ s.show(); });
  },
  close:function(){
    if(this.drawer){
      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden','true');
    }
    if(this.overlay)this.overlay.classList.remove('open');
    document.body.style.overflow='';
    var lf=this.lastFocus;
    this.lastFocus=null;
    if(lf&&lf.isConnected&&typeof lf.focus==='function'){
      try{ lf.focus({preventScroll:true}); }catch(e){ lf.focus(); }
    }
  },
  refresh:function(){
    var s=this;
    return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      /* The protection may need adding, removing or re-tiering. When it writes to
         the cart it re-runs this method, so stop here and render the settled cart. */
      if(SP.sync(c)) return;
      SP.tries=0;
      var net=SP.netCents(c), real=SP.realCount(c);
      s.updateCount(real);
      s.updateShip(net);
      s.renderItems(c.items);
      s.updateTotal(c.total_price);   /* the shopper does pay the protection */
      s.toggleFooter(real);
      SP.render(c);
      Upsell.renderCart(c);
      /* Lets the cart page keep its own summary in step without a reload. */
      document.dispatchEvent(new CustomEvent('onx:cart',{detail:c}));
    }).catch(function(e){console.warn('Cart refresh failed',e)});
  },
  toggleFooter:function(n){
    var show=n>0?'':'none';
    var ftr=document.querySelector('.cdw__ftr');
    if(ftr)ftr.style.display=show;
    /* The drawer no longer renders accelerated wallet buttons — Shopify's
       component forced one full-width button per row in a 420px container. The
       lookup is kept harmless rather than removed in case the block is ever
       reinstated behind a wider container. */
    var exp=document.getElementById('cdw-express');
    if(exp)exp.hidden=!(n>0);
  },
  updateCount:function(n){
    document.querySelectorAll('[data-cc]').forEach(function(el){
      el.textContent=n;
      // Only the round header badge toggles visibility; inline title counts stay inline
      if(el.classList.contains('cbadge'))el.style.display=n>0?'flex':'none';
    });
  },
  /* A free-shipping code won on the wheel is applied to the session, but Shopify
     doesn't surface shipping discounts in /cart.js — they only appear at checkout.
     The wheel records the win locally, so read that and reflect it in the bar. */
  spinFreeShip:function(){
    /* Requires the spin section to actually be on the page. It renders nothing when
       Spin to Win is disabled, so a shopper who won free shipping months ago stops
       being shown "free shipping unlocked" in the drawer once the promo is switched
       off — otherwise a stale localStorage win keeps promising free freight (and an
       expired code) right up to checkout. */
    if(!document.querySelector('.spin')) return false;
    try{ return !!(JSON.parse(localStorage.getItem('onx_spin_v2')||'{}').freeShip); }
    catch(e){ return false; }
  },
  updateShip:function(cents){
    var au=window.ONX&&window.ONX.au;
    if(this.spinFreeShip()){
      if(this.shipTxt)this.shipTxt.innerHTML='<strong>Free shipping unlocked \ud83c\udf89</strong>';
      if(this.fillEl)this.fillEl.style.width='100%';
      this.updateNote(cents,au);
      return;
    }
    if(this.shipTxt){
      if(!au){this.shipTxt.innerHTML='Shipping calculated at checkout';}
      else{
        var rem=this.thresh-cents;
        if(rem<=0){this.shipTxt.innerHTML='<strong>You\'ve unlocked FREE shipping! 🎉</strong>';}
        else{this.shipTxt.innerHTML='You\'re <strong>'+this.fmt(rem)+'</strong> away from free shipping 🇦🇺';}
      }
    }
    if(this.fillEl){this.fillEl.style.width=au?Math.min(100,cents/this.thresh*100)+'%':'0%';}
    this.updateNote(cents,au);
  },
  updateNote:function(cents,au){
    var note=document.getElementById('cdw-shipnote');
    if(!note)return;
    if(this.spinFreeShip()){
      note.innerHTML='\u2713 Free shipping unlocked \u2014 apply your code at checkout';
      note.style.color='#16a34a';
      return;
    }
    if(!au){note.innerHTML='+ shipping &amp; taxes calculated at checkout';note.style.color='var(--muted)';return;}
    var rem=this.thresh-cents;
    if(rem>0){note.innerHTML='Add '+this.fmt(rem)+' more for FREE shipping 🇦🇺';note.style.color='var(--accent)';}
    else{note.innerHTML='✓ FREE shipping unlocked';note.style.color='#16a34a';}
  },
  updateTotal:function(c){if(this.totalEl)this.totalEl.textContent=this.fmt(c);var co=document.getElementById('co-amt');if(co)co.textContent=this.fmt(c);},
  renderItems:function(items){
    if(!this.itemsEl)return;
    if(!items.length){
      this.itemsEl.innerHTML='<div style="text-align:center;padding:52px 16px"><p style="font-family:var(--head);font-weight:900;font-size:19px;text-transform:uppercase;margin-bottom:8px">Your cart is empty</p><p style="font-size:14px;color:var(--muted);margin-bottom:24px">Find parts engineered for your bike.</p><a href="/collections/all" class="btn btn--dk btn--sm" onclick="Cart.close()">Shop All Parts</a></div>';
      return;
    }
    items=items.filter(function(it){ return !SP.isDG(it); });
    if(!items.length){
      this.itemsEl.innerHTML='<div style="text-align:center;padding:52px 16px"><p style="font-family:var(--head);font-weight:900;font-size:19px;text-transform:uppercase;margin-bottom:8px">Your cart is empty</p><p style="font-size:14px;color:var(--muted);margin-bottom:24px">Find parts engineered for your bike.</p><a href="/collections/all" class="btn btn--dk btn--sm" onclick="Cart.close()">Shop All Parts</a></div>';
      return;
    }
    this.itemsEl.innerHTML=items.map(function(it){
      var saveLine='';
      if(it.compare_at_price&&it.compare_at_price>it.price){
        var sav=it.compare_at_price-it.price;
        if(sav>0)saveLine='<div style="font-size:10px;color:var(--accent);font-family:var(--head);font-weight:700;letter-spacing:.06em;text-transform:uppercase;margin-top:2px">Save '+Cart.fmt(sav)+'</div>';
      }
      return '<div class="ci" data-key="'+it.key+'"><img class="ci__img" src="'+it.image+'" alt="'+it.product_title+'" loading="lazy"><div><div class="ci__name">'+it.product_title+'</div>'+(it.variant_title&&it.variant_title!=='Default Title'?'<div class="ci__var">'+it.variant_title+'</div>':'')+saveLine+'<div class="ci__row"><div class="qc"><button class="qb" data-a="dec" data-key="'+it.key+'" data-q="'+it.quantity+'">−</button><span class="qn">'+it.quantity+'</span><button class="qb" data-a="inc" data-key="'+it.key+'" data-q="'+it.quantity+'">+</button><button class="qb" data-a="rm" data-key="'+it.key+'" style="margin-left:4px;font-size:11px">✕</button></div><span class="ci__price">'+Cart.fmt(it.final_line_price)+'</span></div></div></div>';
    }.bind(this)).join('');
    var s=this;
    this.itemsEl.querySelectorAll('[data-a]').forEach(function(b){
      b.addEventListener('click',function(){
        var a=b.dataset.a,k=b.dataset.key,q=parseInt(b.dataset.q);
        if(a==='inc')s.changeQty(k,q+1);
        if(a==='dec')s.changeQty(k,Math.max(0,q-1));
        if(a==='rm')s.changeQty(k,0);
      });
    });
  },
  qtyBusy:false,
  changeQty:function(key,qty){
    if(this.qtyBusy)return;        /* a second tap mid-request would post a stale quantity */
    this.qtyBusy=true;
    var s=this;
    if(s.itemsEl)s.itemsEl.classList.add('citems--busy');
    function done(){ s.qtyBusy=false; if(s.itemsEl)s.itemsEl.classList.remove('citems--busy'); }
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(){ return s.refresh(); })
      .then(done).catch(done);
  },
  _nf:null,
  fmt:function(c){
    var cur=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'AUD';
    if(!this._nf||this._nf.cur!==cur){
      var f=null;
      /* narrowSymbol keeps AUD as "$" to match the store's money_format rather
         than rendering "A$"; older engines that reject the option fall back. */
      try{ f=new Intl.NumberFormat(undefined,{style:'currency',currency:cur,currencyDisplay:'narrowSymbol'}); }
      catch(e){ try{ f=new Intl.NumberFormat(undefined,{style:'currency',currency:cur}); }catch(e2){ f=null; } }
      this._nf={cur:cur,f:f};
    }
    if(this._nf.f){ try{ return this._nf.f.format(c/100); }catch(e){} }
    return '$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');
  }
};

/* ── SHIPPING PROTECTION ────────────────────────
   Optional paid add-on. Config comes from snippets/sp-config.liquid, which is
   driven by Theme settings -> Shipping Protection; no variant ID appears in
   this file. The cart is the single source of truth: the toggle always renders
   from what Shopify actually holds, never from what we last asked for.

   TIER CURRENCY. Shopify serves /cart.js in the visitor's PRESENTMENT currency,
   so a US$500 cart is not an A$500 cart. Shopify injects the shop->presentment
   rate as Shopify.currency.rate (verified present in content_for_header), so
   dividing by it converts back to store currency, which is the basis the tier
   boundaries are written in. Markets that also apply a per-market price
   adjustment are approximated by the FX rate alone, which can nudge a cart to
   the next tier up; the fee itself is converted by Shopify like any other price.

   EXCLUSIONS. The protection never counts toward its own tier, the free-shipping
   threshold, the upsell gap or the item count. It IS in the subtotal and the
   checkout total, because the customer pays it.
*/
var SP={
  cfg:null, busy:false, tries:0,
  KEY:'onx_protection_choice',   /* sessionStorage: '1' chosen on, '0' chosen off, absent = untouched */

  init:function(){
    var el=document.getElementById('sp-config');
    if(!el) return;
    try{ this.cfg=JSON.parse(el.textContent); }catch(e){ this.cfg=null; return; }
    if(!this.cfg||!this.cfg.enabled||!this.cfg.tiers||!this.cfg.tiers.length){ this.cfg=null; return; }
    var s=this;
    document.addEventListener('change',function(e){
      var t=e.target;
      if(!t||!t.hasAttribute||!t.hasAttribute('data-sp-toggle')) return;
      s.choose(t.checked);
    });
  },

  /* Store-currency cents from presentment cents. */
  baseCents:function(cents){
    var r=1;
    try{ r=parseFloat(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.rate); }catch(e){}
    if(!r||!isFinite(r)||r<=0) r=1;
    return Math.round(cents/r);
  },

  /* A line is the protection if it's that product, or carries our own marker —
     so an ID change in settings can't orphan a line already in someone's cart. */
  isDG:function(it){
    if(!this.cfg) return false;
    if(this.cfg.pid && it.product_id===this.cfg.pid) return true;
    return !!(it.properties && it.properties._onx_protection);
  },
  dgLines:function(cart){ var o=[],s=this; (cart.items||[]).forEach(function(i){ if(s.isDG(i)) o.push(i); }); return o; },
  netCents:function(cart){ var n=0,s=this; (cart.items||[]).forEach(function(i){ if(!s.isDG(i)) n+=i.final_line_price; }); return n; },
  realCount:function(cart){ var n=0,s=this; (cart.items||[]).forEach(function(i){ if(!s.isDG(i)) n+=i.quantity; }); return n; },

  tierFor:function(baseC){
    var t=this.cfg.tiers,pick=t[0];
    for(var i=0;i<t.length;i++){ if(baseC>=t[i].min) pick=t[i]; }
    return pick;
  },

  /* Default OFF: with no explicit choice we fall back to cfg.defaultOn, which
     ships false. Flipping that one setting is the whole change to go ON. */
  wanted:function(){
    try{ var v=sessionStorage.getItem(this.KEY); if(v==='1') return true; if(v==='0') return false; }catch(e){}
    return !!this.cfg.defaultOn;
  },
  choose:function(on){
    try{ sessionStorage.setItem(this.KEY,on?'1':'0'); }catch(e){}
    this.tries=0;
    this.setBusyUI(true);
    Cart.refresh();
  },

  /* Brings the cart in line with the wanted state. Returns true if it issued a
     write, in which case it re-runs Cart.refresh() itself and the caller should
     stop — the next pass renders the settled cart. */
  sync:function(cart){
    if(!this.cfg||this.busy) return false;
    var lines=this.dgLines(cart), real=this.realCount(cart);

    /* Runaway guard: never loop on a cart we can't satisfy. */
    if(this.tries>4){ if(this.tries===5){ console.warn('[Shipping Protection] stopped syncing after repeated attempts'); this.tries=6; } return false; }

    if(real===0) return lines.length ? this.wipe(lines) : false;      /* no products -> no fee */
    if(!this.wanted()) return lines.length ? this.wipe(lines) : false;
    if(lines.length===0) return this.add(this.tierFor(this.baseCents(this.netCents(cart))));
    if(lines.length>1) return this.wipe(lines);                        /* collapse duplicates, re-added next pass */

    var it=lines[0], tier=this.tierFor(this.baseCents(this.netCents(cart)));
    if(it.variant_id!==tier.vid || it.quantity!==1) return this.swap(it,tier);
    return false;
  },

  post:function(url,body){
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
  },
  done:function(){ this.busy=false; this.setBusyUI(false); Cart.refresh(); },
  fail:function(e){ console.warn('[Shipping Protection]',e); this.busy=false; this.setBusyUI(false); Cart.refresh(); },

  wipe:function(lines){
    var s=this,u={};
    lines.forEach(function(l){ u[l.key]=0; });
    s.busy=true; s.tries++;
    s.post('/cart/update.js',{updates:u}).then(function(){ s.done(); }).catch(function(e){ s.fail(e); });
    return true;
  },
  add:function(tier){
    var s=this; s.busy=true; s.tries++;
    s.post('/cart/add.js',{items:[{id:tier.vid,quantity:1,properties:{_onx_protection:'1'}}]})
      .then(function(r){ if(!r.ok) throw new Error('add rejected — is the protection product Active and published to the Online Store channel?'); s.done(); })
      .catch(function(e){ s.fail(e); });
    return true;
  },
  swap:function(it,tier){
    var s=this,u={}; u[it.key]=0;
    s.busy=true; s.tries++;
    s.post('/cart/update.js',{updates:u})
      .then(function(){ return s.post('/cart/add.js',{items:[{id:tier.vid,quantity:1,properties:{_onx_protection:'1'}}]}); })
      .then(function(r){ if(!r.ok) throw new Error('tier swap rejected'); s.done(); })
      .catch(function(e){ s.fail(e); });
    return true;
  },

  setBusyUI:function(on){
    document.querySelectorAll('[data-sp-root]').forEach(function(r){ r.classList.toggle('sprot--busy',!!on); });
    document.querySelectorAll('[data-sp-toggle]').forEach(function(t){ t.disabled=!!on; });
  },

  /* Renders every instance (drawer + cart page) from real cart state. */
  render:function(cart){
    var roots=document.querySelectorAll('[data-sp-root]');
    if(!roots.length) return;
    if(!this.cfg){ roots.forEach(function(r){ r.hidden=true; }); return; }
    var real=this.realCount(cart);
    if(real===0){ roots.forEach(function(r){ r.hidden=true; }); return; }
    var lines=this.dgLines(cart), on=lines.length>0;
    var tier=on&&lines[0].variant_id
      ? (this.cfg.tiers.filter(function(t){return t.vid===lines[0].variant_id;})[0]||this.tierFor(this.baseCents(this.netCents(cart))))
      : this.tierFor(this.baseCents(this.netCents(cart)));
    var label=on ? Cart.fmt(lines[0].final_line_price) : Cart.fmt(tier.price);
    roots.forEach(function(r){
      r.hidden=false;
      r.classList.toggle('sprot--on',on);
      var p=r.querySelector('[data-sp-price]'); if(p)p.textContent=label;
      var t=r.querySelector('[data-sp-toggle]'); if(t&&t.checked!==on)t.checked=on;
    });
  }
};

/* ── ADD TO CART ──────────────────────────────── */
var ATC={
  init:function(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-atc]');
      if(!btn)return;
      e.preventDefault();
      ATC.add(btn);
    });
    var form=document.getElementById('pform');
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var b=form.querySelector('[data-atc]');
        if(b)ATC.add(b);
      });
    }
  },
  busy:false,
  add:function(btn){
    if(this.busy)return;          /* a second click mid-request is ignored */
    // Get id from button data-id or from hidden form input
    var id=btn.dataset.id;
    if(!id){
      var form=btn.closest('form')||document.getElementById('pform');
      var inp=form&&form.querySelector('[name="id"]');
      id=inp&&inp.value;
    }
    if(!id)return;
    this.busy=true;
    var orig=btn.innerHTML;
    btn.disabled=true;
    btn.innerHTML='<span style="opacity:.6">Adding...</span>';
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:parseInt(id),quantity:1})
    }).then(function(r){
      if(!r.ok)throw new Error('OOS');
      btn.innerHTML='✓ Added';
      /* Only now that Shopify has confirmed the line: render the cart, then
         reveal the drawer. Opening after the render means no empty flash and no
         race with Shipping Protection re-tiering. The black "Added to cart"
         toast used to fire here too — redundant once the drawer itself opens. */
      return Cart.openAfterRefresh().then(function(){
        setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;ATC.busy=false;},2400);
      });
    }).catch(function(e){
      btn.innerHTML=e.message==='OOS'?'Out of Stock':'Error — try again';
      setTimeout(function(){btn.innerHTML=orig;btn.disabled=false;ATC.busy=false;},2400);
    });
  }
};

/* ── UPSELLS ──────────────────────────────────────
   Two surfaces, one pool:
   - Cart drawer: picks add-ons that close the free-shipping gap, re-run on every
     cart change. Skips anything already in the cart.
   - Product page: server-renders a fallback, then swaps in Shopify's own
     complementary products when the merchant has set them in Search & Discovery.
*/
var Upsell={
  pool:[], cartMax:4,
  init:function(){
    var el=document.getElementById('ups-pool');
    if(el){
      try{ this.pool=JSON.parse(el.textContent)||[]; }
      catch(e){ this.pool=[]; console.warn('Upsell pool parse failed',e); }
    }
    this.enhancePDP();
  },
  fmt:function(c){return Cart.fmt(c);},

  /* Choose up to cartMax add-ons given the live cart. */
  pick:function(cart){
    var inCart={};
    (cart.items||[]).forEach(function(i){ inCart[i.product_id]=true; });
    var spPid=SP.cfg&&SP.cfg.pid;
    var avail=this.pool.filter(function(p){ return !inCart[p.pid] && p.pid!==spPid; });
    if(!avail.length) return {items:[],reason:''};

    var au=window.ONX&&window.ONX.au;
    var gap=au?(Cart.thresh-SP.netCents(cart)):0;

    if(gap>0){
      // Cheapest single item that gets them over the line, if one exists.
      var closers=avail.filter(function(p){ return p.price>=gap; })
                       .sort(function(a,b){ return a.price-b.price; });
      if(closers.length){
        var rest=avail.filter(function(p){ return p.pid!==closers[0].pid; })
                      .sort(function(a,b){ return a.price-b.price; });
        return {items:[closers[0]].concat(rest.slice(0,this.cartMax-1)),
                reason:'Add '+this.fmt(gap)+' more to unlock free shipping'};
      }
      // Nothing closes it alone — offer the cheapest, they still narrow the gap.
      return {items:avail.sort(function(a,b){return a.price-b.price;}).slice(0,this.cartMax),
              reason:'Add '+this.fmt(gap)+' more to unlock free shipping'};
    }
    return {items:avail.sort(function(a,b){return a.price-b.price;}).slice(0,this.cartMax),reason:''};
  },

  row:function(p){
    var cmp = (p.cmp&&p.cmp>p.price) ? '<s class="ups__was">'+this.fmt(p.cmp)+'</s>' : '';
    var img = p.img ? '<img src="'+p.img+'" alt="" loading="lazy" width="64" height="64">' : '';
    var act = p.multi
      ? '<a href="'+p.url+'" class="ups__add">Options</a>'
      : '<button type="button" class="ups__add" data-atc data-id="'+p.vid+'">+ Add</button>';
    return '<div class="ups__item" data-ups-pid="'+p.pid+'">'+
             '<a href="'+p.url+'" class="ups__img" tabindex="-1" aria-hidden="true">'+img+'</a>'+
             '<div class="ups__body">'+
               '<a href="'+p.url+'" class="ups__title">'+p.title+'</a>'+
               '<span class="ups__price">'+this.fmt(p.price)+cmp+'</span>'+
             '</div>'+act+
           '</div>';
  },

  renderCart:function(cart){
    var wrap=document.getElementById('ups-cart');
    var list=document.getElementById('ups-cart-list');
    var lbl=document.getElementById('ups-cart-label');
    if(!wrap||!list)return;
    if(!SP.realCount(cart)||!this.pool.length){ wrap.hidden=true; return; }
    var res=this.pick(cart);
    if(!res.items.length){ wrap.hidden=true; return; }
    list.innerHTML=res.items.map(this.row.bind(this)).join('');
    /* The heading used to be assigned ONLY when pick() returned a reason, so once
       the shopper crossed the free-shipping threshold the reason went empty and
       the stale "Add $X more to unlock free shipping" text was left on screen —
       contradicting the bar above it, which correctly said unlocked. Always
       assign: the gap message when there is a gap, otherwise the merchant's own
       heading, carried on the element as data-default. */
    if(lbl) lbl.textContent = res.reason || lbl.getAttribute('data-default') || 'Add to your order';
    wrap.hidden=false;
  },

  /* Swap the server-rendered fallback for Shopify's complementary products. */
  enhancePDP:function(){
    var box=document.getElementById('ups-pdp');
    if(!box)return;
    var pid=box.dataset.upsProduct, lim=box.dataset.upsLimit||3;
    if(!pid)return;
    fetch('/recommendations/products.json?product_id='+pid+'&limit='+lim+'&intent=complementary')
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(d){
        if(!d||!d.products||!d.products.length)return;   // keep the fallback
        var list=document.getElementById('ups-pdp-list');
        if(!list)return;
        list.innerHTML=d.products.filter(function(p){return p.available;}).map(function(p){
          return Upsell.row({
            pid:p.id, vid:(p.variants[0]||{}).id, title:p.title, price:p.price,
            cmp:p.compare_at_price||0, url:p.url,
            img:p.featured_image?p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2'):'',
            multi:p.variants.length>1
          });
        }).join('');
      })
      .catch(function(){});   // network failure just leaves the fallback in place
  }
};

/* ── ADD-TO-CART TOAST ────────────────────────── */
/* The add-to-cart toast was removed: the drawer now opens on every successful
   add, so a toast saying the same thing was duplicate confirmation competing
   with it. Its markup and styles are gone too. */

/* ── MOBILE NAV ───────────────────────────────── */
var MNav={
  nav:null,
  open:function(){
    if(!this.nav)return;
    // Span the full screen height (top:0 + bottom:0 avoids dvh/vh gaps on mobile)
    this.nav.style.top='0';
    this.nav.style.bottom='0';
    this.nav.style.height='auto';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.style.top='0';ov.classList.add('open');}
    this.nav.classList.add('open');
    document.body.style.overflow='hidden';
  },
  close:function(){
    if(!this.nav)return;
    this.nav.classList.remove('open');
    this.nav.style.top='';
    this.nav.style.bottom='';
    this.nav.style.height='';
    var ov=document.getElementById('mnav-ov');
    if(ov){ov.classList.remove('open');ov.style.top='';}
    document.body.style.overflow='';
  },
  init:function(){
    var self=this;
    self.nav=document.getElementById('mnav');
    var tog=document.getElementById('mbtn');
    var cls=document.getElementById('mnav-close');
    var ov=document.getElementById('mnav-ov');
    if(tog)tog.addEventListener('click',function(e){e.stopPropagation();self.open();});
    if(cls)cls.addEventListener('click',function(){self.close();});
    var pull=document.getElementById('mnav-pull-close');
    if(pull)pull.addEventListener('click',function(){self.close();});
    if(ov)ov.addEventListener('click',function(){self.close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')self.close();});
    /* Accordion: only one section open at a time. With three dropdowns the menu
       could otherwise run to ~1400px of scrolling on a phone. Also scrolls the
       section it just opened into view, since opening the last one used to push
       its contents below the fold. */
    if(self.nav){
      var drops=Array.prototype.slice.call(self.nav.querySelectorAll('.mnav__drop'));
      drops.forEach(function(d){
        d.addEventListener('toggle',function(){
          if(!d.open)return;
          drops.forEach(function(o){ if(o!==d) o.open=false; });
          var links=self.nav.querySelector('.mnav__links');
          if(!links)return;
          // Wait for the browser to lay the panel out before measuring
          requestAnimationFrame(function(){
            var top=d.offsetTop, bottom=top+d.offsetHeight;
            if(bottom > links.scrollTop + links.clientHeight){
              links.scrollTo({ top: Math.max(0, bottom - links.clientHeight + 12), behavior:'smooth' });
            }
          });
        });
      });
    }

    if(self.nav){
      var sx=0;
      self.nav.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
      self.nav.addEventListener('touchend',function(e){
        if(e.changedTouches[0].clientX-sx<-50)self.close();
      },{passive:true});
      var links=self.nav.querySelector('.mnav__links');
      if(links){
        links.addEventListener('touchstart',function(e){e.stopPropagation();},{passive:true});
        links.addEventListener('touchmove',function(e){e.stopPropagation();},{passive:true});
      }
    }
  }
};

/* ── DESKTOP NAV DROPDOWNS ────────────────────────
   "Shop By Bike" and "E-Moto Brakes" are <button>s with no href, and the menu
   opened only via CSS :hover / :focus-within. On touchscreen laptops and hybrid
   pointer devices that meant tapping them did nothing at all — two of six primary
   nav categories were dead with no link to fall back on. Adds click toggling,
   real aria-expanded state, outside-click and Escape.
*/
var NavDrop={
  init:function(){
    var drops=Array.prototype.slice.call(document.querySelectorAll('.nav__drop'));
    if(!drops.length)return;
    function closeAll(except){
      drops.forEach(function(d){
        if(d===except)return;
        d.classList.remove('open');
        var b=d.querySelector('.nav__drop-btn');
        if(b)b.setAttribute('aria-expanded','false');
      });
    }
    drops.forEach(function(d){
      var btn=d.querySelector('.nav__drop-btn');
      if(!btn)return;
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        var willOpen=!d.classList.contains('open');
        closeAll(d);
        d.classList.toggle('open',willOpen);
        btn.setAttribute('aria-expanded',willOpen?'true':'false');
      });
      // Pointer users still get hover; keep the class in step so state is consistent
      d.addEventListener('mouseleave',function(){
        d.classList.remove('open');
        btn.setAttribute('aria-expanded','false');
      });
    });
    document.addEventListener('click',function(e){
      if(!e.target.closest('.nav__drop'))closeAll(null);
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape')closeAll(null);
    });
  }
};

/* ── SCROLL REVEAL ────────────────────────────── */
var Reveal={
  init:function(){
    if(!('IntersectionObserver' in window)){
      document.querySelectorAll('.rv-anim').forEach(function(e){e.classList.add('vis')});
      return;
    }
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vis');obs.unobserve(e.target);}});
    },{threshold:.08,rootMargin:'0px 0px -24px 0px'});
    document.querySelectorAll('.rv-anim').forEach(function(el){obs.observe(el);});
  }
};

/* ── DRAG SCROLL (reviews carousel) ──────────── */
function dragScroll(el){
  if(!el)return;
  var down=false,sx,sl;
  el.addEventListener('mousedown',function(e){down=true;el.style.cursor='grabbing';sx=e.pageX-el.offsetLeft;sl=el.scrollLeft;});
  el.addEventListener('mouseleave',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mouseup',function(){down=false;el.style.cursor='grab';});
  el.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();el.scrollLeft=sl-(e.pageX-el.offsetLeft-sx)*1.4;});
}

/* ── INIT ─────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){
  SP.init();
  Cart.init();
  ATC.init();
  Upsell.init();
  MNav.init();
  NavDrop.init();
  Reveal.init();
  document.querySelectorAll('.rv-scroll').forEach(dragScroll);
});

/* Expose Cart.close for inline onclick in empty cart state */
window.Cart=Cart;

})();
